const MAX = 64;

const browserOf = (agent: string): string => {
    if (/edg\//i.test(agent)) return 'Edge';
    if (/firefox\/|fxios/i.test(agent)) return 'Firefox';
    if (/chrome\/|crios/i.test(agent)) return 'Chrome';
    if (/safari\//i.test(agent)) return 'Safari';
    return '';
};

const systemOf = (agent: string): string => {
    if (/iphone|ipod/i.test(agent)) return 'iPhone';
    if (/ipad/i.test(agent)) return 'iPad';
    if (/android/i.test(agent)) return 'Android';
    if (/windows nt/i.test(agent)) return 'Windows';
    if (/mac os x/i.test(agent)) return 'Mac';
    if (/linux/i.test(agent)) return 'Linux';
    return '';
};

export const passkeyNameClean = (value: string): string => value.replace(/[\p{Cc}\p{Cf}]/gu, '').slice(0, MAX);

export default function passkeyDeviceName(agent: string): string {
    const browser = browserOf(agent);
    const system = systemOf(agent);
    if (browser && system) return `${browser} su ${system}`;
    return browser || system || 'Questo dispositivo';
}

export const PASSKEY_NAME_MAX = MAX;
